module.exports = new __parcel__URL__("generic-empty-state.1b007192.svg").toString();